/* eslint-disable import/prefer-default-export */
import moment, { Moment } from 'moment';
import { isMobile } from 'react-device-detect';
import { MisDatosConstants } from '../../utils/MisDatosConstants';
import { PersonalData, PrefijoPais } from '../../types/PersonalData';
import DataService from '../../services/MisDatosService';
import { CryptoUtil } from '../../utils/CryptoUtil';

export class MisDatosHelper {
  getExpresionRegularEmail = () => {
    return new RegExp(
      // eslint-disable-next-line no-control-regex
      /^((([a-z]|\d|[!#$%&'*+\-/=?^_`{|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#$%&'*+\-/=?^_`{|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)(((((\x20)|(\x09))*(\x0d\x0a))?((\x20)|(\x09))+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*((((\x20)|(\x09))*(\x0d\x0a))?((\x20)|(\x09))+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i,
    );
  };

  transformarTipoDocKosmosANumber = (tipoDocKosmos: string) => {
    switch (tipoDocKosmos) {
      case MisDatosConstants.TIPO_DOC_DNI_KOSMOS:
        return MisDatosConstants.TIPO_DOC_DNI;
      case MisDatosConstants.TIPO_DOC_PASAPORTE_KOSMOS:
        return MisDatosConstants.TIPO_DOC_PASAPORTE;
      case MisDatosConstants.TIPO_DOC_NIE_TARJETA_RESIDENCIA_KOSMOS:
        return MisDatosConstants.TIPO_DOC_NIE_TARJETA_RESIDENCIA;
      case MisDatosConstants.TIPO_DOC_CIF_KOSMOS:
        return MisDatosConstants.TIPO_DOC_CIF;
      default:
        return MisDatosConstants.TIPO_DOC_OTROS;
    }
  };

  validatePassport = (passport: string): boolean => {
    const maxLength9 = (elem: string) => /^[A-Za-z0-9]{1,9}$/.test(elem);
    const allEqualChars = (elem: string) => !/^(.)\1*$/.test(elem);

    const notConsecutive = (elem: string) =>
      Array.from(elem).some(
        (char, index, array) =>
          index < array.length - 1 &&
          Math.abs(char.charCodeAt(0) - array[index + 1].charCodeAt(0)) !== 1,
      );

    const moreThan4Distinct = (elem: string) =>
      new Set(Array.from(elem)).size > 4;

    const validations = {
      maxLength9: maxLength9(passport),
      allEqualChars: allEqualChars(passport),
      notConsecutive: notConsecutive(passport),
      moreThan4Distinct: moreThan4Distinct(passport),
    };

    return Object.values(validations).every(Boolean);
  };

  validarPasaporteCIF = (value: any, tipoDocumento: number) => {
    const expRegPassport = new RegExp(/^([a-zA-Z]*[0-9]+[a-zA-Z]*)$/);
    const expRegCif = new RegExp(
      /[KPQSW][0-9]{7}[A-Z]|[ABEH][0-9]{8}|[CDFGJL-NRUV][0-9]{7}[0-9A-Z]/,
    );
    let isValid = false;
    switch (parseInt(tipoDocumento.toString(), 10)) {
      case MisDatosConstants.TIPO_DOC_PASAPORTE:
        if (expRegPassport.test(value)) {
          if (expRegCif.test(value)) {
            isValid = true;
          }
        }
        break;
      default:
        break;
    }
    return isValid;
  };

  validarTipoDni = (value: any, tipoDocumento: number) => {
    const expRegDni = new RegExp(/^[0-9]{8}[a-zA-Z]$/);
    const expRegNie = new RegExp(/^[a-zA-Z][0-9]{7}[a-zA-Z]$/);
    const expRegCif = new RegExp(
      /[KPQSW][0-9]{7}[A-Z]|[ABEH][0-9]{8}|[CDFGJL-NRUV][0-9]{7}[0-9A-Z]/,
    );
    let isValid = false;
    switch (parseInt(tipoDocumento.toString(), 10)) {
      case MisDatosConstants.TIPO_DOC_DNI:
        if (expRegDni.test(value)) {
          isValid = true;
        }
        break;
      case MisDatosConstants.TIPO_DOC_PASAPORTE: {
        if (this.validatePassport(value)) {
          isValid = true;
        }
        break;
      }
      case MisDatosConstants.TIPO_DOC_NIE_TARJETA_RESIDENCIA:
        if (expRegNie.test(value)) {
          isValid = true;
        }
        break;
      case MisDatosConstants.TIPO_DOC_CIF:
        if (expRegCif.test(value)) {
          isValid = true;
        }
        break;
      default:
        isValid = true;
    }
    return isValid;
  };

  logicaPrefijos = (prefijosVo: any, personalData: PersonalData) => {
    if (
      personalData.tipoUsuario !== MisDatosConstants.ID_TIPO_USUARIO_GIBRALTAR
    ) {
      if (
        prefijosVo.prefijo === MisDatosConstants.PREFIJO_INGLATERRA ||
        prefijosVo.prefijo === MisDatosConstants.PREFIJO_GIBRALTAR
      ) {
        return false;
      }
    } else if (prefijosVo.prefijo === MisDatosConstants.PREFIJO_INGLATERRA) {
      return false;
    }

    return true;
  };

  getPrefijoTextvalue = (prefijoId: string) => {
    const prefijoSelector = document.getElementById(
      prefijoId,
    ) as HTMLSelectElement;
    const optionElement = prefijoSelector
      ? (prefijoSelector[prefijoSelector?.selectedIndex] as HTMLOptionElement)
      : null;
    return optionElement?.text;
  };

  private expRegTelfSpain = [
    new RegExp(/(^(6|7)[0-9]{8}$)/),
    new RegExp(/(^[6789][0-9]{8}$)/),
  ];

  private expRegTelfGibraltar = [
    new RegExp(/(^(54|56|57|58|60)[0-9]{6}$)/),
    new RegExp(/(((^200|^216|^222)[0-9]{5}$)|(^(54|56|57|58|60)[0-9]{6}$))/),
  ];

  private expRegTelfEngland = [
    new RegExp(/(^[7][0-9]{9}$)/),
    new RegExp(/(^[127][0-9]{9}$)/),
  ];

  private expRegTelfAndorra = [
    new RegExp(/(^(3|4|6)[0-9]{5}$)/),
    new RegExp(/(^[0-9]{6}$)/),
  ];

  testTelefono = (
    prefijoId: string,
    phone: string,
    isTlfSecundario?: boolean,
  ) => {
    console.log('prefijoId: ', prefijoId);
    console.log('phone: ', phone);
    console.log('isTlfSecundario: ', isTlfSecundario);
    const prefijoText = this.getPrefijoTextvalue(prefijoId) || '34';
    // if (prefijoText === undefined || prefijoText === null) return true;

    const index = isTlfSecundario ? 1 : 0; // Selecciona la expresión regular basada en si es teléfono secundario o no

    const regexMap = {
      [MisDatosConstants.PREFIJO_ESPANIA]: this.expRegTelfSpain[index],
      [MisDatosConstants.PREFIJO_GIBRALTAR]: this.expRegTelfGibraltar[index],
      [MisDatosConstants.PREFIJO_INGLATERRA]: this.expRegTelfEngland[index],
      [MisDatosConstants.PREFIJO_ANDORRA]: this.expRegTelfAndorra[index],
    };

    const pattern = regexMap[prefijoText];

    return pattern.test(phone);
  };

  testTelefonoCarga = (
    prefijoId: string,
    phone: string,
    personalData: PersonalData,
    isTlfSecundario?: boolean,
  ) => {
    console.log('prefijoId: ', prefijoId);
    console.log('phone: ', phone);
    console.log('isTlfSecundario: ', isTlfSecundario);
    const prefijoText = this.getPrefijoTextvalue(prefijoId) || '34';

    const index = isTlfSecundario ? 1 : 0; // Selecciona la expresión regular basada en si es teléfono secundario o no

    const regexMap = {
      [MisDatosConstants.PREFIJO_ESPANIA]: this.expRegTelfSpain[index],
      [MisDatosConstants.PREFIJO_GIBRALTAR]: this.expRegTelfGibraltar[index],
      [MisDatosConstants.PREFIJO_INGLATERRA]: this.expRegTelfEngland[index],
      [MisDatosConstants.PREFIJO_ANDORRA]: this.expRegTelfAndorra[index],
    };

    const pattern = regexMap[prefijoText as string];

    return pattern.test(phone);
  };

  testCarnet = (carnet: string, maxLength: number, required: boolean) => {
    let patternResult = true;
    if (carnet) {
      if (carnet.length > 0 || required) {
        const carnetNumber = carnet
          .replace(new RegExp('(/|_)', 'g'), '')
          .trim();
        const expRegCarnet = new RegExp(/^[\d]{12}$/);
        patternResult =
          expRegCarnet.test(carnetNumber) || carnetNumber.length === maxLength;
      }
    } else if (required) {
      patternResult = false;
    }
    return patternResult;
  };

  valueCarnet = (carnet: string) => {
    return carnet.replace(new RegExp('(/|_)', 'g'), '');
  };

  isAsciiPrintableEmail = (value: string) => {
    let isValid = false;
    let element = '' as string;
    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < value.length; index++) {
      element = value[index] as string;
      const ch = element.charCodeAt(0) as number;
      if (
        ch === 45 || // -
        ch === 46 || // .
        (ch >= 48 && ch <= 57) || // numeros
        (ch >= 65 && ch <= 90) || // letras mayusculas
        (ch >= 97 && ch <= 122) || // letras minusculas
        ch === 64 || // caracater @
        ch === 43 || // caracter +
        ch === 95 // caracter _
      ) {
        isValid = true;
      } else {
        return false;
      }
    }
    return isValid;
  };

  isCorporativeEmail = async (value: string) => {
    const mailEncriptado = btoa(CryptoUtil.encryptAes(value));
    const data = {
      email: mailEncriptado,
    };
    const response = await DataService.getCorporativeMail(data);
    return !response.data.error;
  };

  checkValidFecha = (fecha: string) => {
    if (fecha !== '') {
      const date = moment(fecha, 'YYYY-MM-DD') as Moment;
      const fechaMayorEdad = moment().add(-18, 'y') as Moment;
      return date.isSameOrBefore(fechaMayorEdad);
    }
    return false;
  };

  // validación de la fecha de nacimiento que lanza el error si es menor de 18 años
  validateBornDate = (fecha: string, setErrorBornDate: any) => {
    const isValidDate = this.checkValidFecha(fecha);
    setErrorBornDate(!isValidDate);
    return isValidDate;
  };

  switchTipoUsuario = (tipoUsuario: any) => {
    if (tipoUsuario) {
      const tipoU = tipoUsuario as number;
      return tipoU === MisDatosConstants.ID_TIPO_USUARIO_EMPRESA
        ? MisDatosConstants.TIPO_EMPRESA_UPDATE
        : MisDatosConstants.TIPO_PARTICULAR_UPDATE;
    }
    return MisDatosConstants.TIPO_EMPRESA_UPDATE;
  };

  checkTerminateValidFecha = (fecha: string) => {
    if (fecha !== '' || fecha !== null) {
      const date = moment(fecha, 'YYYY-MM-DD') as Moment;
      const today = moment() as Moment;
      return date.isAfter(today);
    }
    return false;
  };

  getLiteralIdiomasFromIdEco = (idioma: string) => {
    switch (idioma) {
      case MisDatosConstants.ID_CATALAN:
        return 'Català';
      case MisDatosConstants.ID_EUSKERA:
        return 'Euskara';
      case MisDatosConstants.ID_GALLEGO:
        return 'Galego';
      case MisDatosConstants.ID_INGLES:
        return 'English (Just in the online supermarket)';
      case MisDatosConstants.ID_ALEMAN:
        return 'Deutch (nur im Supermarkt Online)';
      default:
        return 'Español';
    }
  };

  validarGenero = (setErrorGenero: any) => {
    let isValidGenero = false;
    const ratioGeneroHombre = document.getElementById(
      `hombre`,
    ) as HTMLInputElement;
    const ratioGeneroMujer = document.getElementById(
      `mujer`,
    ) as HTMLInputElement;

    if (ratioGeneroHombre && ratioGeneroMujer) {
      if (ratioGeneroHombre.checked || ratioGeneroMujer.checked) {
        isValidGenero = true;
      }
    } else {
      isValidGenero = true;
    }
    if (isValidGenero) {
      setErrorGenero(false);
    } else {
      setErrorGenero(true);
    }
    return isValidGenero;
  };

  formatearEspecificacionesDelInputTelefono1 = (
    prefijoPais: PrefijoPais[],
    selectedItem: number,
  ) => {
    const prefijoPaisEncontrado: PrefijoPais | undefined = prefijoPais.find(
      (currentValue) => currentValue.id === selectedItem,
    );
    if (prefijoPaisEncontrado) {
      return prefijoPaisEncontrado;
    }
    return null;
  };

  retrievePrefijoByCountry = (
    e: React.FormEvent<HTMLSelectElement>,
    tipo: string,
    prefijosPaises: PrefijoPais[],
    personalData: PersonalData,
    setPrefijoMovil: any,
    setPrefijoSec?: any,
    setTamTelfMovil?: any,
    setTamTelfSec?: any,
    setPersonalData?: any,
  ) => {
    const selectedId = Number(e.currentTarget.value);
    if (tipo === 'movil') {
      prefijosPaises.forEach((currentValue) => {
        if (currentValue.id === selectedId) {
          setPrefijoMovil(currentValue.prefijo);
          setPersonalData({
            ...personalData,
            prefijoTelefono: selectedId,
          });
          setTamTelfMovil(currentValue.tamanioTelefono);
        }
      });
    }
    if (tipo === 'secundario') {
      const defaultPrefijo = {
        id: 1,
        pais: 'España',
        predefinido: 1,
        prefijo: '34',
        tamanioTelefono: 9,
      };
      let encontrado = false;
      prefijosPaises.forEach((currentValue) => {
        if (currentValue.id === selectedId) {
          encontrado = true;
          setPrefijoSec(currentValue.prefijo);
          setPersonalData({
            ...personalData,
            prefijoTelefonoSecundario: selectedId,
          });
          setTamTelfSec(currentValue.tamanioTelefono);
        }
      });
      if (!encontrado) {
        setPrefijoSec(defaultPrefijo.prefijo);
        setPersonalData({
          ...personalData,
          prefijoTelefonoSecundario: defaultPrefijo.id,
        });
        setTamTelfSec(defaultPrefijo.tamanioTelefono);
      }
    }
  };

  comprobarPrefijoSecundario = () => {
    const paisTelefonoSecSelect = document.getElementById(
      `pais-telefono-sec`,
    ) as HTMLSelectElement;
    const paisTelefonoMovilSecundarioInput = document.getElementById(
      `pais-telefono-secundario`,
    ) as HTMLInputElement;
    if (paisTelefonoMovilSecundarioInput.value) {
      return (paisTelefonoSecSelect.value as unknown) as number;
    }
    return null;
  };

  prefixErrorValidation = (prefijoId: string, isTlfSecundario?: boolean) => {
    let lang = 'validaciones.not-valid-phone-spain';
    const tlf = isTlfSecundario ? '2' : '';
    switch (prefijoId) {
      case MisDatosConstants.PREFIJO_GIBRALTAR:
        lang = `validaciones.not-valid-phone${tlf}-gibraltar`;
        break;
      case MisDatosConstants.PREFIJO_INGLATERRA:
        lang = `validaciones.not-valid-phone${tlf}-england`;
        break;
      case MisDatosConstants.PREFIJO_ANDORRA:
        lang = `validaciones.not-valid-phone${tlf}-andorra`;
        break;
      default:
        lang = `validaciones.not-valid-phone${tlf}-spain`;
    }
    return lang;
  };

  testSocioConsumidor = (
    tipoSocio: number | undefined,
    isBloqued: boolean | undefined,
  ) => {
    return (
      isBloqued !== true &&
      (tipoSocio === MisDatosConstants.TIPO_SOCIO_CONSUMIDOR_ANTIGUO ||
        tipoSocio === MisDatosConstants.TIPO_SOCIO_CONSUMIDOR ||
        tipoSocio === MisDatosConstants.TIPO_SOCIO_AMBOS_ANTIGUO)
    );
  };

  scrollToResponsive = (padre: HTMLDivElement) => {
    padre.scrollIntoView(true);
    const cabecera = document.getElementsByClassName('header').item(0);
    const isFixed = (cabecera !== null &&
      cabecera.clientWidth < 992) as boolean;
    if (isFixed || isMobile) {
      const yScroll = window.scrollY;
      const heightHeader = cabecera !== null ? cabecera.clientHeight : 64;
      window.scrollTo(0, yScroll - heightHeader);
    }
  };

  setPrefijoTelefono = (value: string) => {
    if (value === '1' || value === '') {
      return '34';
    }
    return '350';
  };
}
